import { FilterType, Filter, FilterKey } from 'api-paths-cas';
import { orderBy } from 'lodash';
import { IGetFilterGroupsProps, RegionSelection } from '../../types';

export const RegionOptions = [
  {
    label: 'UK',
    value: RegionSelection.UK,
  },
  {
    label: 'Middle East',
    value: RegionSelection.MIDDLE_EAST,
  },
  {
    label: 'Africa',
    value: RegionSelection.AFRICA,
  },
  {
    label: 'EU',
    value: RegionSelection.EUROPE,
  },
  {
    label: 'Non-EU Europe',
    value: RegionSelection.NON_EU_EUROPE,
  },
  {
    label: 'Central Asia (CIS)',
    value: RegionSelection.CENTRAL_ASIA,
  },
  {
    label: 'North America',
    value: RegionSelection.NORTH_AMERICA,
  },
  {
    label: 'South America',
    value: RegionSelection.SOUTH_AMERICA,
  },
  {
    label: 'South Asia',
    value: RegionSelection.SOUTH_ASIA,
  },
  {
    label: 'Southeast Asia',
    value: RegionSelection.SOUTHEAST_ASIA,
  },
  {
    label: 'East Asia',
    value: RegionSelection.EAST_ASIA,
  },
];

const key = FilterKey.MARKET;
export const getMarketFilter = ({ activeFilters }: IGetFilterGroupsProps): Filter => {
  const filters = activeFilters[key] ?? [];

  const options = RegionOptions.map(({ label, value }) => {
    return {
      label,
      value,
      checked: filters.some(filter => filter === value),
    };
  });

  const sortedOptions = orderBy(options, [option => option.label.toLowerCase()], ['asc']);

  return {
    name: 'Market (Based on domicile)',
    key,
    type: FilterType.SELECT_MANY,
    showSearch: false,
    options: {
      SELECT_MANY: sortedOptions,
    },
  };
};
